export default {
  index: 'Home Page',
  logOut: 'Log Out',
  profile: 'Personal Center',
  webcomeBack: 'Welcome',
  noName: 'No name yet',
  changeLogo: 'Update the company Logo',
  logoFormatError: 'Please upload an image in the correct format, such as png, jpg, jpeg, gif.',
  innerAccount: "Inner Account",
}
